if (!customElements.get('pastael-announcement-marquee')) {
  class PastaelAnnouncementMarquee extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-marquee-track]');
      this.groups = this.querySelectorAll('[data-marquee-group]');
      if (!this.track || this.groups.length < 2) return;

      this.baseDuration = Number.parseFloat(this.dataset.duration) || 30;

      const primary = this.groups[0];
      if (!this.baseCycleHtml) {
        this.baseCycleHtml = primary.innerHTML.trim();
      }

      this.ensureTrackCoverage();
      this.updateDuration();

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.track.style.animationPlayState = 'paused';
      }

      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => {
          this.ensureTrackCoverage();
          this.updateDuration();
        });
        this.resizeObserver.observe(this);
      } else {
        this.handleResize = this.handleResize.bind(this);
        window.addEventListener('resize', this.handleResize);
      }

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          this.ensureTrackCoverage();
          this.updateDuration();
        });
      }
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      if (this.handleResize) {
        window.removeEventListener('resize', this.handleResize);
      }
    }

    ensureTrackCoverage() {
      const [primary, secondary] = this.groups;
      const containerWidth = this.clientWidth;
      if (!containerWidth || !this.baseCycleHtml) return;

      primary.innerHTML = this.baseCycleHtml;

      let safety = 0;
      while (primary.scrollWidth < containerWidth && safety < 30) {
        primary.insertAdjacentHTML('beforeend', this.baseCycleHtml);
        safety += 1;
      }

      secondary.innerHTML = primary.innerHTML;
    }

    updateDuration() {
      const groupWidth = this.groups[0]?.scrollWidth;
      const containerWidth = this.clientWidth;
      if (!groupWidth || !containerWidth) return;

      const duration = Math.max((groupWidth / containerWidth) * this.baseDuration, 1);
      this.track.style.setProperty('--pastael-marquee-duration', `${duration}s`);
    }
  }

  customElements.define('pastael-announcement-marquee', PastaelAnnouncementMarquee);
}
